import { useDispatch, useSelector } from 'react-redux';
import { Actions } from '../../redux/actions';
import type { RootState } from '../../redux/reducers';
import './_modal.scss';
import ModalTypes from './ModalTypes';

const { modalClose } = Actions;

export const ModalContainer = () => {
  const { open, modalProps, modalType } = useSelector((state: RootState) => state.Modals);
  const dispatch = useDispatch();
  const ModalType = ModalTypes[modalType];

  const close = (res) => {
    dispatch(modalClose());
    if (modalProps?.close) {
      modalProps.close(res);
    }
  };
  return ModalType ? <ModalType {...modalProps} close={close} visible={open} /> : null;
};

export default ModalContainer;
